
import { useState, useContext } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Http from '../../../util/Http';
import UserContext from '../../../context/UserContext';
import KakaoLogin from '../../oAuth/KakaoLogin';
import GoogleLogin from '../../oAuth/GoogleLogin';
import UserApi from '../../../api/UserApi';
import './signin.css';

const DOMAIN = 'mbizsquare.com';

const Login = props => {
    const { user, setUser } = useContext(UserContext);
    const navigate = useNavigate();
    const location = useLocation();
    const [loginId, setLoginId] = useState('');
    const [loginPw, setLoginPw] = useState('');

    // 로그인 후 리다이렉트 처리
    const redirect = () => {
        // document.referrer 확인
        let referrer = document.referrer;
        const innerReferrer = sessionStorage.getItem('referrer');
        if (innerReferrer) {
            referrer = innerReferrer;
            sessionStorage.removeItem('referrer');
        }
        
        if (referrer && referrer.includes(DOMAIN)) {
            try {
                const referrerUrl = new URL(referrer);
                const currentUrl = new URL(window.location.href);
                // origin이 다르면 (서브도메인 포함) 전체 URL로 이동
                if (referrerUrl.origin !== currentUrl.origin) {
                    window.location.href = referrer;
                    return;
                }
                // 같은 도메인인 경우 # 이하 경로만 사용
                const endPoint = referrer.split('#')[1] || '/';
                navigate(endPoint);
                return;
            } catch (e) {
                // URL 파싱 실패 시 무시
                console.log(e);
            }
        }
        
        // 기본값
        navigate('/');
    };

    const handleIdInput = e => setLoginId(e.target.value);
    const handlePwInput = e => setLoginPw(e.target.value); 

    const handleLoginClick = async () => {
        const res = await Http.post('/user/login', {username : loginId, password: loginPw});
        if(res.code === 'success') {
            setUser(res.userInfo);
            redirect();
        } else {
            alert('올바른 아이디 혹은 비밀번호가 아닙니다.');
        }
    }

    const kakaoLoginSuccessCallback = async (accessToken) => {
        const res = await UserApi.loginByKakao(accessToken);
        if(res.code === 'success') {
            setUser(res.userInfo);
            redirect();
        } else {
            window.Kakao.Auth.logout();
            alert(res.message);
        }
    }

    const handlePwKeyup = e => {
        e.preventDefault();
        e.stopPropagation();
        if (e.which !== 13) return;
        handleLoginClick();
    }

    const googleLoginSuccessCallback = async (credential) => {
        const res = await UserApi.loginByGoogle(credential);
        if(res.code === 'success') {
            setUser(res.userInfo);
            redirect();
        } else {
            alert(res.message);
        }
    }

    const handleRegisterClick = () => {
        navigate('/register')
    }

    return (
        <div className="signin-conatainer">
            <div className="signin-content">
                <div className="signin-banner">
                    <div className="signin-logo">
                        <img src="/static/img/logo/new-logo.png" />
                    </div>
                    <h1>
                        <p>플레이스 / 스토어 무료 순위 조회</p>
                        <p>마케팅, 비지니스 정보 공유</p>
                        <p>광고비 아끼는 견적 비교</p>
                        <p>무료 광고분석 대시보드</p>
                        <p>마케팅 자동화</p>
                    </h1>
                    <img src="/static/img/signin_visual.png" />
                </div>
                <div className="signin-form-area">
                    <div className="signin-logo">
                        <img src="/static/img/logo/new-logo.png" />
                    </div>
                    <div className="signin-form">
                        <div className="signin-input">
                            <i className="fa-solid fa-user input-icons"></i>
                            <input type="text" id="username" placeholder="아이디" 
                                value={loginId} onChange={handleIdInput} onKeyUp={handlePwKeyup}
                            />
                        </div>
                        <div className="signin-input">
                            <i className="fa-solid fa-lock input-icons"></i>
                            <input type="password" id="password" placeholder="비밀번호" 
                                value={loginPw} onChange={handlePwInput} onKeyUp={handlePwKeyup}
                            />
                            <button type="button">
                                <i className="fa-solid fa-eye-slash"></i>
                                <i className="fa-solid fa-eye"></i>
                            </button>
                        </div>
                        <div className="signin-tool">
                            <div className="checkbox-group">
                                <input type="checkbox" id="remember-id" />
                                <label for="remember-id">아이디저장</label>
                            </div>
                            <div className="find-options">
                                <Link to="/findInfo?target=id">아이디 찾기</Link> / 
                                <Link to="/findInfo?target=pw">비밀번호 찾기</Link>
                            </div>
                        </div>
                        <div className="signin-form-controls">
                            <button type="button" className="login-btn" onClick={handleLoginClick}>로그인</button>
                        </div>
                        <div className="signin-induce">
                            <p>아직 회원이 아니신가요 ?</p>
                            <a onClick={handleRegisterClick}>회원가입</a>
                        </div>
                        <div className="social-login-api">
                            {/* <a href="" className="button-kakaotalk">카카오톡 로그인</a> */}
                            <KakaoLogin loginSuccessCallback={kakaoLoginSuccessCallback}  />
                            <GoogleLogin loginSuccessCallback={googleLoginSuccessCallback} clientId="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Login;